module.exports = __webpack_public_path__ + "img/taylorBellsCastingHall_20201113_027.bf7d9f8a.jpg";